import type { ButtonProps } from 'antd';
import { Button as AntButton } from 'antd';
import Styles from './Styles.module.scss';
import cs from 'classnames';

export default function Button(props: ButtonProps) {
    return (
        <AntButton
            className={cs(Styles.AntButton, props.className, {
                [Styles.AntButtonDanger]: props.danger,
                [Styles.AntButtonDefault]: props.type === 'default',
            })}
            {...props}
        />
    );
}
